import { jsx, jsxs } from "react/jsx-runtime";
import { Button, Flex, Text } from "pcln-design-system";
import "react";
import { mapPinType } from "../../constants/index.js";
import { MapIcon } from "../Maps/SinglePinIcon.js";
const InlineLocationLink = (props)=>{
    const { pinsInCurrentLine, handleMapButtonClick, metadata } = props;
    return /*#__PURE__*/ jsx(Button, {
        variation: "link",
        style: {
            transform: 'translateY(5px)',
            justifyContent: 'flex-start',
            textAlign: 'left',
            width: 'auto'
        },
        onClick: function(event) {
            event.stopPropagation();
            event.preventDefault();
            handleMapButtonClick(pinsInCurrentLine, metadata);
        },
        children: /*#__PURE__*/ jsxs(Flex, {
            alignItems: "center",
            children: [
                MapIcon({
                    type: metadata?.type,
                    iconProp: {
                        color: 'primary',
                        size: 20
                    }
                }),
                /*#__PURE__*/ jsx(Text.span, {
                    fontSize: 2,
                    ml: 1,
                    bold: metadata.type === mapPinType.HOTEL,
                    children: metadata.name
                })
            ]
        })
    });
};
export { InlineLocationLink };
